export default class BaseApplication
{
  on_post_start()
  {}

  on_enter()
  {}

  on_exit()
  {}

  update()
  {}

  on_post_render()
  {}

  on_pre_render()
  {}
}
